import { createContext, useState } from 'react';

export type SelectedStudyContextType = {
  npNote: string;
  setNPNote: (npNote: string) => void;
  resetNPNote: () => void;
  resetSelectedStudyValues: () => void;
  notReferAfterNote?: boolean;
  setNotReferAfterNote: (notRefer: boolean) => void;
  notCompleteAfterNote?: boolean;
  setNotCompleteAfterNote: (notComplete: boolean) => void;
};

export const SelectedStudy = createContext<SelectedStudyContextType>({
  npNote: '',
  setNPNote: () => null,
  resetNPNote: () => null,
  resetSelectedStudyValues: () => null,
  notReferAfterNote: false,
  setNotReferAfterNote: () => null,
  notCompleteAfterNote: false,
  setNotCompleteAfterNote: () => null,
});

const SelectedStudyProvider = ({ children }: { children: React.ReactNode }) => {
  const [npNote, setNPNote] = useState<string>('');
  const [notReferAfterNote, setNotReferAfterNote] = useState<boolean>(false);
  const [notCompleteAfterNote, setNotCompleteAfterNote] = useState<boolean>(false);

  const resetNPNote = () => {
    setNPNote(() => '');
  };

  const resetSelectedStudyValues = () => {
    resetNPNote();
    if (notReferAfterNote) {
      setNotReferAfterNote(false);
    }
    if (notCompleteAfterNote) {
      setNotCompleteAfterNote(false);
    }
  };

  return (
    <SelectedStudy.Provider
      value={{
        npNote,
        setNPNote,
        resetNPNote,
        notReferAfterNote,
        setNotReferAfterNote,
        notCompleteAfterNote,
        setNotCompleteAfterNote,
        resetSelectedStudyValues,
      }}
    >
      {children}
    </SelectedStudy.Provider>
  );
};

export default SelectedStudyProvider;
